import * as React from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import { Container, Header } from 'semantic-ui-react'
import Awards from './Awards'

const clientLogos = [
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/EY.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/VALE.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/PROGEN.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/METRO.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/SUPERVIA.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/BTG_PACTUAL.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/ABB.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/ALUNORTE.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/INVEPAR.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/EXPRESSO_LINHA_6.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/PORTO_SUDESTE.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/ANGLO_FERROUS.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/LAMSA.png',
  '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_250,h_150/LOGOTIPOS/PREFEITURA_DE_SANTOS.png',
]

const Clients = () => {
  return (
    <Container id='clients' textAlign='center'>
      <Header size='huge' textAlign='center'>
        Clientes
      </Header>
      <Carousel
        className='clients-carousel'
        showThumbs={false}
        centerMode
        infiniteLoop
        autoPlay
        interval={2000}
        emulateTouch
        showStatus={false}
        showIndicators={false}
        centerSlidePercentage={25}
      >
        {clientLogos.map((src, i) => (
          <img src={src} className='img-responsive' alt='//' key={i} />
        ))}
      </Carousel>
      <Awards />
    </Container>
  )
}

export default Clients
